import React from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/logo_fsky.png";
import "./thankyou.css";

const Thankspage = () => {
  return (
    <div
      className="body-inner"
      style={{
        width: "100%",
        height: "100vh", 
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column", 
      }}
    >
      <h4 style={{ textAlign:"center"}}>Thank You for Visiting First Sky Infrastructure! 
      </h4>
      <a href="/constructionpage">
        <img src={logo} alt="FAZO Academy Logo" width="120" />
      </a>
      <h1 className="m-t-50 font-weight-bold text-success">Thanking you</h1>
      <p className="lead" style={{ textAlign:"center"}}>
        <strong>We appreciate your trust in us.</strong><br></br><br></br>
        Let's craft something extraordinary together!

        {/* <strong>Your Dream, Our Expertise!</strong> */}
      </p>
      <Link
        to="/constructionpage" className="thankpage"
        style={{
          backgroundColor:"#354169",
          color: "#FDC30B",
          margin: "20px",
          padding: "10px",
          borderRadius: "5px",
          textDecoration: "none",
          
        }}
      >
        Go to home page
      </Link>
    </div>
  );
};

export default Thankspage;
